<template>
  <div class="container container-shadow login-container">
      <el-form :model="formVal" :rules="formRules" ref="formVal" class="login-box">

        <el-form-item prop="email" class="form-row">
            <el-input type="text" v-model="formVal.email" placeholder="Email" auto-complete="off"></el-input>
        </el-form-item>
      
        <el-form-item prop="password" class="form-row password-row">
            <div class="btn-show-password" @click="togglePw" :class="{'open':passType==='text'}"></div>
            <el-input :type="passType" v-model="formVal.password" placeholder="Password" auto-complete="off"></el-input>
        </el-form-item>
        <div class="form-row form-button">
          <el-button :loading="btnLoading" @click="submitForm('formVal')">Login</el-button>
        </div> 
        <div class="login-tips">
          <router-link tag="span" :to="{name:'forgotPassword'}" class="forget-password">Forget password?</router-link>
          <p>Don't have an account? <router-link tag="span" :to="{name:'register'}" class="create-one">Create one now!</router-link></p>
          <router-link tag="p" :to="{name:'PhoneCodeLogin'}" class="verifycode-login">Login using your registered mobile number.</router-link>
        </div>
      </el-form>
  </div>
</template>

<script>
import { validatePass, validateEmailNeedExist } from 'utils/validate'
import { login, isLogin } from 'service/login'
export default {
  data() {
    return {
      btnLoading: false,
      passType: 'password',
      formVal: {
        email: '',
        password: ''
      },
      formRules: {
        email: [
          { required: true, message: 'Required.', trigger: 'blur' },
          {
            type: 'email',
            message: 'Invalid email format.',
            trigger: ['blur']
          },
          { validator: validateEmailNeedExist, trigger: 'blur' }
        ],
        password: [{ validator: validatePass, trigger: 'blur' }]
      }
    }
  },
  created() {
    isLogin().then(res => {
      if (res.code === 200) {
        this.$router.push({ name: 'memberIndex' })
      }
    })
    this.$store.commit('set_title', 'Login')
  },
  methods: {
    togglePw() {
      if (this.passType === 'password') {
        this.passType = 'text'
      } else {
        this.passType = 'password'
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnLoading = true
          login(this.formVal)
            .then(res => {
              console.log('rse', res)
              localStorage.uk_token = res.token
              this.btnLoading = false
              this.$router.push({ name: 'memberIndex' })
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';

.login-container {
  height: 482px;
}
.login-box {
  width: 530px;
  min-height: 200px;
  margin: 0 auto;
  .logo {
    margin: 0 auto;
  }

  .login-tips {
    font-size: 14px;
    line-height: 30px;
    margin-top: 12px;
    color: #333333;
    span {
      color: #0A95FF;
      cursor: pointer;
    }
    .create-one {
      text-decoration: underline;
    }
    .verifycode-login {
      text-decoration: underline;
      color: #0A95FF;
      cursor: pointer;
    }
    .forget-password {
      float: right;
      text-decoration: underline;
      color: #0A95FF;
    }
  }
}
</style>
